import React from 'react'
// import event_tab_img from '../../assets/images/event_tab_img.png'
import EventAllTabSection from '../EventAllTabSection'
import EventSectionTabButtons from '../EventSectionTabButtons'
const EventTabSection = () => {
    return (
        <>
            <div className=''>
                <EventSectionTabButtons />
                <div className='border w-full mt-2.5 border-solid border-slate'>
                    <div className='p-[5px] lg:p-5'>
                        <EventAllTabSection />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EventTabSection